import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useInventorySystemProfile } from '../../hooks/useInventorySystemProfile'
import { DetailEntityPage } from '../DetailEntityPage/DetailEntityPage'
import { Badge } from '../../components/Badge/Badge'
import { BuildStatusBadge } from '../../components/BuildStatusBadge/BuildStatusBadge'
import { AvailabilityBadge } from '../../components/AvailabilityBadge/AvailabilityBadge'
import { TenantGroupBadge } from '../../components/TenantGroupBadge/TenantGroupBadge'
import { formatDate } from '../../helpers/formatDate'
import type { DetailFieldDef } from '../../types'

export function InventorySystemProfileDetailPage() {
  const { id } = useParams<{ id: string }>()
  const { profile, isLoading, error } = useInventorySystemProfile(id ?? '')

  const fields: DetailFieldDef[] = profile
    ? [
        {
          label: 'ID',
          value: <span className="font-monospace small">{profile.id}</span>,
        },
        {
          label: 'Code',
          value: <span className="fw-medium">{profile.code}</span>,
        },
        { label: 'Name', value: profile.name },
        {
          label: 'Type',
          value: <Badge color="grey">{profile.inventorySystemType}</Badge>,
        },
        {
          label: 'Build Schedule',
          value: <Badge color="grey">{profile.buildSchedule}</Badge>,
        },
        {
          label: 'Build Status',
          value: <BuildStatusBadge status={profile.buildStatus} />,
        },
        {
          label: 'Availability Build',
          value: (
            <AvailabilityBadge enabled={profile.availabilityBuildEnabled} />
          ),
        },
        {
          label: 'Tenant Group',
          value: <TenantGroupBadge tenantGroupId={profile.tenantGroupId} />,
        },
        { label: 'Created', value: formatDate(profile.createdAt) },
        { label: 'Updated', value: formatDate(profile.updatedAt) },
      ]
    : []

  return (
    <DetailEntityPage
      title={
        profile
          ? `Inventory System Profile - ${profile.code}`
          : 'Inventory System Profile'
      }
      loadingLabel="inventory system profile"
      fields={fields}
      isLoading={isLoading}
      error={error}
      actions={
        id ? (
          <Link
            to={`/inventory-system-profiles/${id}/edit`}
            className="btn btn-primary btn-sm"
          >
            Edit
          </Link>
        ) : undefined
      }
    />
  )
}
